/**
 * Engine base-URL derivation, shared by raw `fetch` callers that need
 * to hit Auth.js form endpoints directly (e.g. `api/otp.ts`,
 * `api/auth.ts`).
 *
 * Reads `VITE_ENGINE_BASE_URL` from `import.meta.env` (default
 * `http://localhost:9171`, the engine's dev port) and strips a single
 * trailing slash so `${engineBaseUrl}${path}` (path leading with `/`)
 * joins cleanly. Mirrors the derivation already in `lib/http.ts`.
 */

const DEFAULT_BASE_URL = "http://localhost:9171"

const envBase = import.meta.env.VITE_ENGINE_BASE_URL
const rawBase = typeof envBase === "string" && envBase.length > 0 ? envBase : DEFAULT_BASE_URL

export const engineBaseUrl = rawBase.endsWith("/") ? rawBase.slice(0, -1) : rawBase
